import { useMemo } from 'react';

import { useUserSessionRegions } from 'dibs-regional-info/exports/regionalInfoHelpers';

export const useUserShippingRegionsUrlLabels = (): string[] | undefined | null => {
    const userRegions = useUserSessionRegions();
    return useMemo(() => {
        return userRegions ? userRegions?.map(region => region.urlLabel) : userRegions;
    }, [userRegions]);
};
